<div class="ad-hoc-upload-container">
  <div class="ad-hoc-upload">
    <div class="file-uploader-container">
      <app-file-uploader
        [tenantId]="tenantId"
        (uploadedDocumentIdsEvent)="startAdHocFiling($event)"
        (errorEvent)="handleDocumentUploadError($event)"
      ></app-file-uploader>
    </div>
  </div>
</div>
<p-toast
  position="bottom-right"
  key="errorToast"
  class="error-toast"
>
  <ng-template
    let-message
    pTemplate="message"
  >
    <div class="toast-message-container">
      <div class="icon-container">
        <i class="fa-solid fa-circle-exclamation"></i>
      </div>
      <div class="message-container">
        <span class="message-summary">{{ message.summary | translate }}</span>
        <span>{{ message.detail | translate }}</span>
        @if (message.data) {
          <span>{{ message.data }}</span>
        }
      </div>
    </div>
  </ng-template>
</p-toast>
